import React, { useState, useEffect } from 'react'
import { Box, Table, TableCell } from "grommet"

import Spinner from '../common/Spinner'

import Warn from '../common/Warn'

import { gql, useSubscription } from '@apollo/client';

import { MDTrader, MarketDataModel, MarketGridRow, MarketGridHeader } from '../prices/Utility'
import { EdgeViewType } from '../prices/Forms'
import AgDataTable from '../common/AgDataTable'



const TASK_QUERY = gql`
subscription($taskId: String!) {
    jobtask(where: {taskid: {_eq: $taskId}}) {
        taskid
        result
        status
      }
}
`

const ResultView = ({ mdmodel, viewPort, mderror }) => {
    if (viewPort === 'MDTrader') {
        return (
            <MDTrader mdmodel={mdmodel} />
        )
    } else if (viewPort === 'MarketGrid') {
        return (
            <MarketGridRow mdmodel={mdmodel} />
        )
    }
}

const TriageSnapShotTable = ({ content, result, taskDataLoading, setErrors }) => {

    const tab_col = [
        {
            field: "environment",
            headerName: "Environment",
            hide: true
        },
        {
            field: "dc",
            headerName: "DataCenter",
            minWidth: 150,
        },
        {
            field: "hostname",
            headerName: "Hostname",
            minWidth: 150,
        },
        {
            field: "error",
            headerName: "Error",
            sort: 'asc',
            minWidth: 150,
        },
        {
            field: "status",
            headerName: "status",
            minWidth: 150,
        },
        {
            field: "exchange_ts",
            headerName: "exchange_ts",
            minWidth: 150,
        },
        {
            field: "bid",
            headerName: "bid price/qty",
            minWidth: 150,
        },
        {
            field: "ask",
            headerName: "bid ask/ask",
            minWidth: 150,
        },
        {
            field: "settle",
            headerName: "settle",
            minWidth: 150,
        },
        {
            field: "high",
            headerName: "high",
            minWidth: 150,
        },
        {
            field: "low",
            headerName: "low",
            minWidth: 150,
        },
    ]

    const [tab_data, set_tab_Data] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        if (result && result.state && result.state === 'SUCCESS' && result.results && result.results[0].triage_results) {
            Object.keys(result.results[0].triage_results).forEach(dc => {
                const nodes = result.results[0].triage_results[dc][0].responses
                nodes.forEach(node => {

                    const nodeData = node.wire.payload[0]
                    let snapshot_response = nodeData.snapshot_response.output

                    let error = ""
                    let priceData = {}

                    if (snapshot_response.includes("error:")) {
                        error = snapshot_response
                    } else {
                        priceData = JSON.parse(snapshot_response)
                    }

                    let status = ''
                    let exchange_ts = ''
                    let stats_price = {}
                    let ask = []
                    let bid = []

                    if (Object.keys(priceData).length > 0) {
                        status = priceData.status ? priceData.status : null
                        exchange_ts = priceData.db.exchange_ts ? new Date(priceData.db.exchange_ts / 1000 / 1000) : null
                        stats_price = priceData.stats_price ? priceData.stats_price : {}
                        ask = priceData.db.asks ? priceData.db.asks[0] : []
                        bid = priceData.db.bids ? priceData.db.bids[0] : []
                    }

                    tab_data_temp.push({
                        "environment": nodeData.cli_server.environment,
                        "hostname": nodeData.cli_server.hostname,
                        "server_id": nodeData.cli_server.server_id,
                        "snapshot_response": snapshot_response,
                        "error": error,
                        "dc": dc,
                        "uniqueId": nodeData.cli_server.server_id,
                        "status": status,
                        "exchange_ts": exchange_ts,
                        "settle": stats_price.settle,
                        "high": stats_price.high ? stats_price.high : null,
                        "low": stats_price.low ? stats_price.low : null,
                        "ask": ask.length > 0 ? ask[0] + "/" + ask[1] : null,
                        "bid": bid.length > 0 ? bid[0] + "/" + bid[1] : null,
                    })

                });
            })
            set_tab_Data(tab_data_temp)
        }
    }, [result, result.state, content])

    return (
        <AgDataTable
            tab_col={tab_col}
            tab_data={tab_data}
            tableName="PriceTableSnap"
        />
    )
}


const TriageSnapShotModel = ({ content, result, taskDataLoading, viewPort = "MDTrader", setErrors }) => {

    const [consolidatedResults, setConsolidatedResults] = useState([])
    const [edgeserverModel, setEdgeserverModel] = useState([])

    useEffect(() => {
        // Support multiple-snapshot
        if (!taskDataLoading && content.taskid.indexOf("MANUAL") === -1 &&
            content.appname === "edgeserver" && content.commandname === "multiple_snapshot" &&
            result && result.results) {
            let edgeserver_mdmodel = []
            let consolidatedResults_temp = []
            let errors_temp = []

            if (result.results instanceof Array) {
                result.results.forEach(r => {
                    if (r && r.triage_results) {
                        const triageResult = r.triage_results
                        Object.keys(triageResult).forEach(dc => {
                            consolidatedResults_temp = consolidatedResults_temp.concat((triageResult[dc])[0].responses)
                        })
                    } else if (r && !r.error) {
                        let mdmodel = new MarketDataModel()
                        mdmodel.parseEdgeSnapshot(r)
                        edgeserver_mdmodel.push(mdmodel)
                    } else if (r && r.error) {
                        errors_temp.push(r.error)
                    }
                })
                setConsolidatedResults(consolidatedResults_temp)
                setEdgeserverModel(edgeserver_mdmodel)
                setErrors(errors_temp)
            }
        }
    }, [content.appname, content.commandname, content.taskid, result, setErrors, taskDataLoading])

    if (!result) {
        return <TableCell></TableCell>
    }

    return (
        <>

            {!taskDataLoading && content.taskid.indexOf("MANUAL") === -1 && result &&
                content.appname === "edgeserver" &&
                content.commandname === "multiple_snapshot" &&
                consolidatedResults.length > 0 &&
                consolidatedResults.map(_triageResult => {
                    let cli_response = _triageResult
                    let mdmodel = new MarketDataModel()
                    let payload = ''

                    if (cli_response.wire && cli_response.wire.payload && cli_response.wire.payload.length > 0) {
                        payload = cli_response.wire.payload[0]

                        if (payload.snapshot_response && payload.snapshot_response.output) {
                            let snapshotRaw = payload.snapshot_response.output
                            if (!snapshotRaw.includes("error:")) {
                                const snapshot = JSON.parse(snapshotRaw)
                                if (snapshot.db.bids && snapshot.db.asks) {
                                    mdmodel.parsePSSnapshot(snapshotRaw, payload.cli_server.hostname)
                                    return (
                                        <ResultView mdmodel={mdmodel} key={content.taskid + '_' + payload.cli_server.hostname} viewPort={viewPort} />
                                    )
                                }
                                return (
                                    <Box />
                                )
                            }
                            return (
                                <Box />
                            )
                        } else {
                            return (<Box />)
                        }
                    } else {
                        return (<Box />)
                    }
                }

                )

            }

            {!taskDataLoading && edgeserverModel &&
                edgeserverModel.map(es_model =>
                    <ResultView mdmodel={es_model} key={content.taskid + '_' + es_model.source} viewPort={viewPort} />
                )

            }

        </>
    )
}

const TriageSnapshotResult = ({ content }) => {

    const [result, setResult] = useState(false)
    const [viewPort, setViewPort] = useState("Table")
    const [errors, setErrors] = useState([])

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: content.taskid } }
    )

    useEffect(() => {
        if (!taskDataLoading && taskResult && taskResult.jobtask &&
            taskResult.jobtask[0].status && taskResult.jobtask.length > 0
            && taskResult.jobtask[0].status !== 0 && !(content.taskid.includes("MANUAL"))
        ) {
            setResult(taskResult.jobtask[0].result)
        }
    }, [content, taskDataLoading, taskResult])

    return (
        <>
            <Box margin={{ left: "20px", top: "5px", bottom: "20px" }}>
                <EdgeViewType
                    viewPort={viewPort}
                    setViewPort={setViewPort}
                />
            </Box>

            {errors.length > 0 &&
                <Box direction="row" margin={{ bottom: "5px", top: "10px", left: "20px", right: "20px" }}>
                    <Warn warning="The following errors occurred while attempting price snapshot" subWarning={errors.toString()} />
                </Box>
            }

            <Box height="90%" overflow={{ horizontal: 'auto', vertical: 'auto' }} gap="small"
                margin={{ left: '10px', top: '30px', bottom: '10px', right: '10px' }} direction="row"
            >

                {viewPort === "Table" &&
                    <Box fill={true} gap="small">
                        <TriageSnapShotTable
                            content={content}
                            result={result}
                            taskDataLoading={taskDataLoading}
                            setErrors={setErrors}
                        />
                    </Box>
                }

                {viewPort === "MDTrader" &&
                    <Box wrap={true} direction="row" gap="small">
                        <TriageSnapShotModel
                            content={content}
                            result={result}
                            taskDataLoading={taskDataLoading}
                            viewPort={viewPort}
                            setErrors={setErrors}
                        />
                    </Box>
                }

                {viewPort === "MarketGrid" &&
                    <Table>
                        <tbody>
                            <MarketGridHeader />
                            <TriageSnapShotModel
                                content={content}
                                result={result}
                                taskDataLoading={taskDataLoading}
                                viewPort={viewPort}
                                setErrors={setErrors}
                            />
                        </tbody>
                    </Table>
                }

            </Box>
            <Box margin={{ left: '20px', top: '20px', right: '20px', bottom: '20px' }}>
                {(((content.taskid.includes("MANUAL")) && result) || taskDataLoading) &&
                    <Spinner />
                }
            </Box>
        </>
    )
}

export default TriageSnapshotResult